export const createMyTasksRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
